/**
 * Directional jump left gesture
 * @module gestures/transforms/jumpLeft
 */
import { createJumpGesture } from './jumpFactory.js';
export default createJumpGesture('left');
